import { render, staticRenderFns } from "./GameLegal.vue?vue&type=template&id=46cfd0e1&"
import script from "./GameLegal.vue?vue&type=script&lang=js&"
export * from "./GameLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports